import React from 'react'
import _ from 'lodash'
import Spinner from 'sharedComponents/Spinner'
import NavbarHeader from 'sharedComponents/NavbarHeader'
import Footer from 'sharedComponents/Footer'
import InkfrogRouter from './sharedComponents/Router.inkfrog'
import AppRouter from './sharedComponents/Router.app'
import SeatRequiredModal from './sharedComponents/SeatRequiredModal'
import { isLiteSubscription } from 'sharedComponents/RangeSelector/planLookback'
import { connect } from 'react-redux'
import { getCookie, setCookie } from 'cookie'
import { sendGtmPixel, pickPrimaryStoreAccount } from 'tagManager'
import { captureWebsiteAttribution } from 'modules/websiteAttribution'
import { isSiteToolsOnly, hasConnectedStore } from 'modules/storeTools'
import qs from 'query-string'
import {
  appLogin,
  inkfrogLogin,
  changeApplication,
  setTopUrl,
  updateQueryJson,
  setSessionSignature,
  setOnboardSkipped,
} from 'actions/rootActions'
import queryString from 'query-string'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { mergeAccessPermissionWithCanonical } from './applications/Settings/views/SharedAccounts/teamPagePermissions'
import LinkWordpressSite from 'applications/LinkWordpressSite'

@connect(
  store => ({
    ...store.root,
    mimicStatus: store.mimic.mimic.status,
    adminFetching: store.userAdmin.fetching,
    accountDetails: store.userLinkedAccounts.userLinkedAccounts,
    subscriptionStatus: store.plan.subscription ? store.plan.subscription.status : null,
    subscription: store.plan.subscription,
    addOns: store.plan.addOns,
    subscriptionActive: store.plan.subscriptionActive,
    upgradeDismissed: store.plan.upgradeDismissed,
    loginFromChannel: store.root.loginFromChannel,
    onboardSkipped: store.root.onboardSkipped,
    seatAssigned: store.root.seatAssigned,
    ownerEmail: store.root.ownerEmail,
  }),
  {
    appLogin,
    inkfrogLogin,
    changeApplication,
    setTopUrl,
    updateQueryJson,
    setSessionSignature,
    setOnboardSkipped,
  }
)
class Root extends React.Component {

  checkSpecialStatus = () => {
    const query = queryString.parse(location.search)
    const { loginStatus, loginStatusMsg } = this.props
    // Store-less WP claim owns its own auth; do not bounce to /login.
    if (location.pathname.startsWith('/link-site')) {
      return (
        <Router future={{ v7_relativeSplatPath: true }}>
          <div style={{ minHeight: 'calc(100vh - 52px)', display: 'flex', flexDirection: 'column' }}>
            <header id="sub-analytics-header">
              <NavbarHeader hasAccounts={false} isLite={false} accessPermissions={{}} />
            </header>
            <div id="sub-analytics-body" style={{ flex: 1 }}>
              <LinkWordpressSite />
            </div>
            <footer id="sub-analytics-footer">
              <Footer />
            </footer>
          </div>
        </Router>
      )
    }
    // Check login status - render layout structure to prevent CLS when full content loads
    // Wrap in Router so NavLinkContainer's useNavigate() hook works
    if (!loginStatus) return (
      <Router future={{ v7_relativeSplatPath: true }}>
        <div style={{ minHeight: 'calc(100vh - 52px)', display: 'flex', flexDirection: 'column' }}>
          <header id="sub-analytics-header">
            <NavbarHeader hasAccounts={false} isLite={false} accessPermissions={{}} />
          </header>
          <div id="sub-analytics-body" style={{ flex: 1, position: 'relative', minHeight: '400px' }}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <Spinner />
            </div>
          </div>
          <footer id="sub-analytics-footer">
            <Footer />
          </footer>
        </div>
      </Router>
    )
    else if (loginStatus === 'failure') {
      // Show dev login page on /login, redirect to /login from other paths
      if (location.pathname === '/login') {
        return (
          <div style={{ maxWidth: 500, margin: '50px auto', padding: 20, fontFamily: 'system-ui' }}>
            <h2>Development Login</h2>
            <p>Run this in your browser console to log in:</p>
            <pre style={{ background: '#f0f0f0', padding: 12, borderRadius: 4, fontSize: 12, overflowX: 'auto' }}>
{`document.cookie = "app_token=ZGV2LXRva2VuLWZvci1sb2NhbC1kZXZlbG9wbWVudC1vbmx5; path=/"`}
            </pre>
            <p style={{ marginTop: 16 }}>Then <a href="/dashboard">click here</a> or refresh the page.</p>
            <p style={{ marginTop: 8, color: '#c00', fontSize: 12 }}>
              ⚠️ Run this snippet on <strong>localhost only</strong>. Pasting it on a *.payhelm.com tab
              creates a host-only cookie that shadows your real OAuth session (issue #530).
            </p>
          </div>
        )
      }
      window.location.href = '/login'
      return (
        <Router future={{ v7_relativeSplatPath: true }}>
          <div style={{ minHeight: 'calc(100vh - 52px)', display: 'flex', flexDirection: 'column' }}>
            <header id="sub-analytics-header">
              <NavbarHeader hasAccounts={false} isLite={false} accessPermissions={{}} />
            </header>
            <div id="sub-analytics-body" style={{ flex: 1, position: 'relative', minHeight: '400px' }}>
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                <Spinner />
              </div>
            </div>
            <footer id="sub-analytics-footer">
              <Footer />
            </footer>
          </div>
        </Router>
      )
    }
    else if (getCookie('waiting_for_close') || query.linking_account === 'true') {
      const ignoreSuccessMessage = getCookie('ignore_success_message')
      if (window !== window.top) {
        // original access from iframe
        setTimeout(() => {
          setCookie('waiting_for_close', '')
          setCookie('pending_success_message', '')
          setCookie('ignore_success_message', '', 1000 * 60 * 5)
        }, 3000)
        return null
      }
      // pop-up window from iframe to link an account, need to close it to avoid non-iframe access
      const successMessage = getCookie('pending_success_message')
      window.onbeforeunload = () => {
        setCookie('waiting_for_close', '')
        setCookie('pending_success_message', '')
        setCookie('ignore_success_message', '', 1000 * 60 * 5)
      }
      return ignoreSuccessMessage ? null : (
        <div className="plain-message pt3">
          <title>{'Payhelm Analytics & Intelligence'}</title>
          <h4>
            <span className='fa fa-check-circle' style={{ color: '#04a778' }}/>&nbsp;
            {
              successMessage || `Your account is linked successfully. Please close the tab.`
            }
          </h4>
        </div>
      )
    }

    return null
  }

  componentDidUpdate(prevProps) {
    if (prevProps.applicationId !== this.props.applicationId || (!prevProps.user.email && this.props.user.email) ) {
      const storeAccount = pickPrimaryStoreAccount(this.props.accounts)
      sendGtmPixel({ page: this.props.applicationId, email: this.props.user.email, storeAccount }, 'pageview')
      // Affiliate tracking: pageview with user identification
      sendGtmPixel({ email: this.props.user.email, userId: this.props.user.id, storeAccount }, 'afftrack_pageview')
    }
  }

  componentDidMount() {
    captureWebsiteAttribution()
    const { appLogin, inkfrogLogin, updateQueryJson, changeApplication, setSessionSignature } = this.props
    const { signature } = qs.parse(location.search)
    if (signature) {
      setSessionSignature(signature)
    }
    // Set top url
    const auth_referer = getCookie('auth_referer')
    let topUrl =
      window.self === window.top
        ? `${window.location.protocol}//${window.location.host}`
        : auth_referer || document.referrer
    this.props.setTopUrl(topUrl)
    // Login
    const query = queryString.parse(location.search)
    const { thirdparty } = query
    if (location.pathname.startsWith('/link-site')) {
      // LinkWordpressSite handles claim + verify; skip appLogin so we don't
      // bounce an unlinked store_less iframe into /login.
    } else if (thirdparty === 'inkfrog') {
      inkfrogLogin()
    } else {
      appLogin()
    }
    // Popstate callback
    window.addEventListener('popstate', () => {
      const nextApplicationId = location.pathname.split('/').filter(t => t && (t !== '/'))[0]
      if (nextApplicationId !== this.props.applicationId) {
        changeApplication(this.props.applicationId, nextApplicationId)
      }
      updateQueryJson()
    })
  }

  render() {
    const {
      thirdParty,
      admin,
      accounts,
      accountDetails,
      subscriptionActive,
      upgradeDismissed,
      applicationId,
      mimicStatus,
      sessionExpired,
      reportTimeCost,
      adminFetching,
      user,
      loginFromChannel,
      onboardSkipped,
      setOnboardSkipped,
      subscription,
      addOns,
      seatAssigned,
      ownerEmail,
    } = this.props

    let hasBigcommerce = accounts.find(account => (account.channel === "Bigcommerce"))
    const hasAccounts = accountDetails.data.details.is_inkfrog
      ? !!accountDetails.data.linked_accounts.length
      : !!accounts.filter(account => account.channel && account.account_name).length
    const storeMarketplaceAccountCount = accounts.filter(account => account.is_store_marketplace_account).length
    // Store-less WooCommerce sites (plugin installed without WooCommerce) count
    // as store-marketplace accounts but have no connected store, so analytics
    // pages would be empty. Route them into the AI site-tools experience. See #730.
    const siteToolsOnly = isSiteToolsOnly(accounts)
    // #693: any user without a connected storefront/marketplace (store-less
    // WooCommerce OR an AI-only account that never connected a store) has no
    // order/product data, so we default them into the AI site-tools experience
    // rather than empty analytics. Broader than `siteToolsOnly`, which requires
    // an existing store-marketplace account.
    const noConnectedStore = !hasConnectedStore(accounts)
    const isOrganizationWorkspace = !!user?.is_organization_workspace
    const specialStatus = this.checkSpecialStatus()
    const rawAccess = user?.access_permission
    const permissionRows = this.props.isOwner
      ? []
      : mergeAccessPermissionWithCanonical((rawAccess as Array<Record<string, unknown>>) || null)
    const accessPermissions = _.chain(permissionRows).keyBy('id').mapValues('checked').value()
    const isLite = isLiteSubscription(subscription, user)

    if (sessionExpired) {
      return (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="p4 center">
            <h4>Your PayHelm session has expired. Please re-login or refresh the page.</h4>
            <Routes><Route path="/error" element={null} /><Route path="*" element={<Navigate to="/error" replace />} /></Routes>
          </div>
        </Router>
      )
    }
    if (specialStatus) return specialStatus

    // Gate non-owner users without an assigned seat on Entrepreneur plan
    const currentPlanProduct = (subscription?.plans || [])[0]?.product
    if (!seatAssigned && !this.props.isOwner && currentPlanProduct === 'Entrepreneur' && !this.state?.seatBypassed) {
      const isMimic = !!mimicStatus
      return <SeatRequiredModal ownerEmail={ownerEmail || ''} onContinue={isMimic ? () => this.setState({ seatBypassed: true }) : undefined} />
    }

    if (thirdParty) return <InkfrogRouter admin={admin} />
    return (
      <AppRouter
        applicationId={applicationId}
        hasAccounts={hasAccounts}
        hasOrgWorkspace={isOrganizationWorkspace || !!user?.is_workspace_context}
        requiresOnboarding={user?.requires_onboarding}
        hasBigcommerce={hasBigcommerce}
        subscriptionActive={subscriptionActive}
        subscription={subscription}
        addOns={addOns}
        upgradeDismissed={upgradeDismissed}
        mimicStatus={mimicStatus}
        reportTimeCost={reportTimeCost}
        admin={admin}
        adminFetching={adminFetching}
        accessPermissions={accessPermissions}
        loginFromChannel={loginFromChannel}
        setOnboardSkipped={setOnboardSkipped}
        onboardSkipped={onboardSkipped}
        isLite={isLite}
        storeMarketplaceAccountCount={storeMarketplaceAccountCount}
        siteToolsOnly={siteToolsOnly}
        noConnectedStore={noConnectedStore}
      />
    )
  }
}

export default Root
